import { render } from "./TeachersTable.vue?vue&type=template&id=dab6973e&scoped=true"
import script from "./TeachersTable.vue?vue&type=script&lang=js"
export * from "./TeachersTable.vue?vue&type=script&lang=js"

import "./TeachersTable.vue?vue&type=style&index=0&id=dab6973e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab6973e"]])

export default __exports__